import bgBottom from './image/bg-bottom.png';
import buy from './image/buy.png';
import bgTop from './image/bg-top.png';
import tele from './image/tele.png';
import devtool from './image/devtool.png';
import x from './image/x.png';

import React, { useEffect } from 'react';
import './App.css';
import analyticsController from './AnalyticsController';

const App = () => {
  useEffect(() => {
    analyticsController.trackPageView({ title: 'Landing' });
  }, []);

  const handleButtonDevtool = () => {
    analyticsController.trackEvent('click_devtool');
    // alert('Button handleButtonDevtool');
  };
  const handleButtonTele = () => {
    analyticsController.trackEvent('click_telegram');
    // alert('Button handleButtonTele');
  };

  const handleButtonX = () => {
    analyticsController.trackEvent('click_x');
    // alert('Button handleButtonX');
  };

  const handleButtonBuy = () => {
    analyticsController.trackEvent('click_buy');
    // window.open("https://apps.apple.com/us/app/make-market-making/id6738039114", '_blank');
  };

  return (
      <div className="container">
        {/* Image bacground */}
        <div className="image-container">
          {/* buy buttons */}
          <div className="social-container">
            <button onClick={handleButtonDevtool} className="image-button-store">
              <img src={devtool} alt="Devtools" />
            </button>
            <button onClick={handleButtonTele} className="image-button-store">
              <img src={tele} alt="Telegram" />
            </button>
            <button onClick={handleButtonX} className="image-button-store">
              <img src={x} alt="X" />
            </button>
            <button onClick={handleButtonBuy} className="image-button-store-2">
              <img src={buy} alt="Buy" />
            </button>
          </div>

          <img src={bgTop} alt="Background top" className="top-image" />
          <img src={bgBottom} alt="Background bottom" className="top-image" />
          {/*<div className="image-logo-container">*/}
          {/*  <p className="overlay-text">DOWNLOAD NOW</p>*/}
          {/*  <button onClick={handleButtonGG} className="image-button">*/}
          {/*    <img src={buttonGoogle} alt="Google Play Button"/>*/}
          {/*  </button>*/}
          {/*  <button onClick={handleButtonApple} className="image-button">*/}
          {/*    <img src={buttonApple} alt="App Store Button"/>*/}
          {/*  </button>*/}
          {/*</div>*/}


          {/* Store buttons */}
          {/*<div className="store-container">*/}
          {/*  <button onClick={handleButtonGG} className="image-button-store">*/}
          {/*    <img src={googlePlay} alt="Google Play Button"/>*/}
          {/*  </button>*/}
          {/*  <button onClick={handleButtonApple} className="image-button-store">*/}
          {/*    <img src={applePlay} alt="App Store Button"/>*/}
          {/*  </button>*/}
          {/*</div>*/}
        </div>
      </div>
  );
};

export default App;
